import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import ProfileAvatar from '../common/ProfileAvatar';
import { reviewAuthorParty, SlotReview } from '../../utils/appointmentReviewDirection';

interface IncomingAppointmentReviewProps {
  title: string;
  authorName: string;
  review: SlotReview;
}

const IncomingAppointmentReview: React.FC<IncomingAppointmentReviewProps> = ({
  title,
  authorName,
  review,
}) => {
  const author = reviewAuthorParty(review);
  const rating = review.rating?.overall || 0;
  let dateLabel = '';
  if (review.createdAt) {
    try {
      dateLabel = formatDistanceToNow(new Date(review.createdAt), { addSuffix: true });
    } catch {
      dateLabel = '';
    }
  }

  return (
    <div className="appointment-details__review">
      <h3 className="appointment-details__review-title">{title}</h3>
      <div className="review-card">
        <div className="review-card__header">
          <div className="review-card__user">
            <ProfileAvatar
              className="review-card__avatar"
              name={authorName}
              photo={author?.profilePhoto}
            />
            <div className="review-card__user-info">
              <div className="review-card__username">{authorName}</div>
              {dateLabel ? <div className="review-card__date">{dateLabel}</div> : null}
            </div>
          </div>
        </div>
        <div className="review-card__rating">
          {[1, 2, 3, 4, 5].map((value) => (
            <span
              key={value}
              className={`review-card__star ${value <= rating ? 'active' : ''}`}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
              </svg>
            </span>
          ))}
        </div>
        {review.review?.text ? (
          <p className="review-card__comment">{review.review.text}</p>
        ) : null}
      </div>
    </div>
  );
};

export default IncomingAppointmentReview;
